import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bleezy-footer-area">
            <div className="footer-top-area section_50" style={{backgroundColor:'#e7791a'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-sm-3">
                            <div className="single-footer-widget footer-logo-widget">
                                <div className="footer-logo">
                                    <Link to="/">
                                        <img src="assets/img/site-logo.jpg" alt="footer logo" style={{borderRadius:'20px'}}/>
                                    </Link>
                                </div>
                                <div className="footer-widget-text">
                                    <p className="font-color-white">OCTOPUSS SECURITY SERVICES PRIVATE LIMITED, a premier ISO 9001:2015 certified Security company in India, provides wide range of Security Services, Manpower Services & Facility Services.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="single-footer-widget">
                                <h3>Security Services</h3>
                                <ul className="font-color-white">
                                    <li><Link to="/services/security-guard/">Security Guard</Link></li>
                                    <li><Link to="/services/bouncer-and-bodyguard/">Bouncer & Bodygruard</Link></li>
                                    <li><Link to="/services/escort-guard/">Escort Guard</Link></li>
                                    <li><Link to="/services/event-security/">Event Security</Link></li>
                                    <li><Link to="/services/tourist-security/">Tourist Security</Link></li>
                                    <li><Link to="/services/school-security/">School Security</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="single-footer-widget">
                                <h3>Manpower Services</h3>
                                <ul className="font-color-white">
                                    <li><Link to="/manpower-service/front-back-office-manpower/">Front & Back office</Link></li>
                                    <li><Link to="/manpower-service/temporary-staffing-solution/">Temp Staffing</Link></li>
                                    <li><Link to="/manpower-service/event-staff/">Event Staff</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="single-footer-widget">
                                <h3>Facility Services</h3>
                                <ul className="font-color-white">
                                    <li><Link to="/facility-service/corporate-housekeeping-service/">HouseKeeping Services</Link></li>
                                    <li><Link to="/facility-service/office-boy/">Office Boy</Link></li>
                                    <li><Link to="/facility-service/pantry-boy/">Pantry Boy</Link></li>
                                    <li><Link to="/facility-service/office-support-service">Office Support Services</Link></li>
                                    {/* <li><Link to="/facility-service/canpactual-staffing-driver">Canpactual Staffing & Driver</Link></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="copyright-area">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="copyright-right">
                                <p>&copy; Copyright <a href="#">Awadh Web Solutions Pvt. Ltd.</a> 2026. All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
export default Footer;  